import React from 'react';
import { motion } from 'framer-motion';

const Contact = () => {
  return (
    <div className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            <span className="text-white">Let’s </span>
            <span className="text-neonGreen">talk</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Tell us about your business and what you’d like to make easier. A new website, less paperwork, an idea you’ve been sitting on—we’ll help you explore what’s possible.
          </p>
        </motion.div>
        
        <div className="text-center py-12 max-w-2xl mx-auto">
          <p className="text-xl text-gray-300">To get started, share what your business does, the problem you want to solve, and your rough budget or timeline.</p>
          <a href="mailto:ImaginationLabsUSA@gmail.com?subject=Let%27s%20talk%20about%20my%20business" className="inline-block mt-8 px-6 py-3 rounded-full bg-gradient-to-r from-neonGreen to-electricBlue text-darkGrey font-semibold break-all">ImaginationLabsUSA@gmail.com</a>
          <p className="text-gray-400 mt-4">Email us to start the conversation.</p>
        </div>
      </div>
    </div>
  );
};

export default Contact; 